/**
 * File vcard.js.
 *
 * When the link is clicked, JavaScript retrieves and decodes the obfuscated email and phone using atob(). These decoded values are then included in the generated vCard.
 */
( function() {
	
	// Select the anchor element with the given classes
    const vCardLink = document.getElementById('vcard');
    if(vCardLink){
		vCardLink.addEventListener('click', function(e) {
			e.preventDefault();
	  
			// Retrieve values from data attributes
			const fullName = vCardLink.getAttribute('data-fullname');
			const title = vCardLink.getAttribute('data-title');
			const company = vCardLink.getAttribute('data-company');
			const website = vCardLink.getAttribute('data-website');
			// Decode the obfuscated email and phone number
			const encodedEmail = vCardLink.getAttribute('data-email');
			const email = encodedEmail ? atob(encodedEmail) : "";
			const encodedPhone = vCardLink.getAttribute('data-phone');
			const phone = encodedPhone ? atob(encodedPhone) : "";
			const photoUrl = vCardLink.getAttribute('data-image') || '';

			// Retrieve location parts.
			const street1 = vCardLink.getAttribute('data-location-street-address-1') || "";
			const street2 = vCardLink.getAttribute('data-location-street-address-2') || "";
			// Merge street1 + street2 into one component with a newline escape
			let streetCombined = street1 || "";
			if (street2) {
			// use a literal “\n” (escaped as \\n in the JS string)  
			streetCombined = street1 
				? `${street1}\\n${street2}` 
				: street2;
			}
			const city = vCardLink.getAttribute('data-location-city') || "";
			const zip = vCardLink.getAttribute('data-location-zip') || "";
			const country = vCardLink.getAttribute('data-location-country') || "";
		
			// Retrieve state and province if set.
			const state = vCardLink.getAttribute('data-location-state') || "";
			const province = vCardLink.getAttribute('data-location-province') || "";
			// Use state if available, otherwise province.
			const region = state ? state : province;
	  
			let vcard = "BEGIN:VCARD\r\nVERSION:3.0\r\n";
	  
			// If fullName exists, add both N: and FN: fields.
			if (fullName) {
			  const names = fullName.split(" ");
			  const firstName = names[0];
			  const lastName = names.slice(1).join(" ");
			  vcard += `N:${lastName};${firstName};;;\r\n`;
			  vcard += `FN:${fullName}\r\n`;
			}

			if ( photoUrl.startsWith('https://') ) {
				vcard += `PHOTO;VALUE=URL;TYPE=JPEG:${photoUrl}\r\n`;
			}
	  
			if (title) {
			  vcard += `TITLE:${title}\r\n`;
			}
			if (company) {
				vcard += `ORG:${company}\r\n`;
			  }
	  
			// Add the address if at least one location field is provided.
			if (street1 || street2 || city || zip || country || region) {
				// vCard ADR format: 
				// ADR;TYPE=WORK:PO Box;Extended Address;Street;City;Region;Postal Code;Country
				// Here, we leave PO Box empty.
				vcard += "ADR;TYPE=WORK:" +
						 // PO Box (empty)
						 ";" +
						 // Extended address (blank)
						 ";" +
						 // Street‐address (combined)
						 `${streetCombined};` +
						 // City
						 `${city};` +
						 // Region (state/province)
						 `${region};` +
						 // Postal code
						 `${zip};` +
						 // Country
						 `${country}` +
						 "\r\n";
			  }
	  
			if (email) {
			  vcard += `EMAIL:${email}\r\n`;
			}
	  
			if (phone) {
			  vcard += `TEL;TYPE=WORK:${phone}\r\n`;
			}

			if (website) {
				vcard += `URL:${website}\r\n`;
			  }
	  
			vcard += "END:VCARD\r\n";
	  
			// Generate a slug from fullName (or default to "contact")
			let filename = "contact.vcf";
			if (fullName) {
			  filename = fullName
				.toLowerCase()
				.trim()
				.replace(/\s+/g, '-')
				.replace(/[^\w\-]+/g, '') + ".vcf";
			}
	  
			// Create and trigger the download using a Blob
			const blob = new Blob([vcard], { type: 'text/vcard' });
			const url = URL.createObjectURL(blob);
			const tempLink = document.createElement("a");
			tempLink.href = url;
			tempLink.download = filename;
			document.body.appendChild(tempLink);
			tempLink.click();
			document.body.removeChild(tempLink);
			URL.revokeObjectURL(url);
		});
	}


}() );
